// extracted by mini-css-extract-plugin
export default {"footerButtons":"Deprecation_modal_footerButtons__Vk4DE"};